import { render, staticRenderFns } from "./monitoring4Detail.vue?vue&type=template&id=4fa02a23"
import script from "./monitoring4Detail.vue?vue&type=script&lang=js"
export * from "./monitoring4Detail.vue?vue&type=script&lang=js"
import style0 from "./monitoring4Detail.vue?vue&type=style&index=0&id=4fa02a23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports